import { useEffect } from "react";
import { onWs } from "../api/ws.js";
import { audio } from "./engine.js";
import { cueForPush, sceneForRoute } from "./score.js";

export function useGameAudio(status: string, settings: { sound: number; music: number; backgroundMusic?: boolean } | null, route: string): void {
  useEffect(() => audio.mount(), []);
  useEffect(() => {
    audio.configure(settings ?? { sound: 0, music: 0, backgroundMusic: false });
  }, [settings?.sound, settings?.music, settings?.backgroundMusic]);
  useEffect(() => {
    audio.setScene(sceneForRoute(route));
    audio.setActive(status === "authed" && route.startsWith("/app"));
  }, [status, route]);
  useEffect(() => onWs("*", (event) => {
    if (event.notification === false) return;
    const cue = cueForPush(event.type, event.payload);
    if (cue) audio.play(cue);
  }), []);
}
